import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { PdfUserGuidesService } from 'src/app/core/services/pdf-user-guides.service';
import { UtilService } from 'src/app/core/services/util.service';
import { UploadSummary } from '../../partials/file-upload/file-upload.component';

@Component({
  selector: 'app-pdf-user-guide-upload',
  templateUrl: './pdf-user-guide-upload.component.html',
  styleUrl: './pdf-user-guide-upload.component.scss'
})
export class PdfUserGuideUploadComponent {

  uploadSummary: UploadSummary[] = [];
  submitting = false;

  constructor(
    public dialogRef: MatDialogRef<PdfUserGuideUploadComponent>,
    private pdfService: PdfUserGuidesService,
    private utilService: UtilService
  ) { }

  async submit() {
    const files = await Promise.all(this.utilService.getQueuedFileContents(this.uploadSummary));
    if (!files.length) {
      this.utilService.openToastr('error', 'Please select a PDF file to upload');
      return;
    }

    const file = files[0];
    if (!file.name.toLowerCase().endsWith('.pdf')) {
      this.utilService.openToastr('error', 'Only PDF files are supported');
      return;
    }

    this.submitting = true;
    this.pdfService.uploadPdf({
      fileName: file.name,
      fileContent: file.fileContentBase64,
    }).subscribe({
      next: () => {
        this.utilService.openToastr('success', 'PDF user guide uploaded');
        this.dialogRef.close(true);
      },
      error: () => {
        this.utilService.openToastr('error', 'Failed to upload PDF user guide');
        this.submitting = false;
      }
    });
  }
}
